var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"custom-icon",attrs:{"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.5 0L8.21927 4.13363L12.6819 4.49139L9.28184 7.40387L10.3206 11.7586L6.5 9.425L2.6794 11.7586L3.71816 7.40387L0.318133 4.49139L4.78073 4.13363L6.5 0Z","fill":"#E4CE00"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }